module.exports = __webpack_public_path__ + "assets/media/doctor_ready.c0972e77.wav";